import { requireCompletedProfile } from "@hisani/auth";
import { validateResumeFields } from "../domain/hire/resume.js";
import { updateResumeSchema } from "../validation.js";
import { resumeResponse } from "./hire-response-projections.js";
/** Every Horseman has one Resume, implicit even before they ever save one
 * (`docs/products/stable.md` "Resume") — private, never disclosed until an
 * application is submitted, so this always reads by identity alone with no
 * Stable-permission check at all. */
export async function getMyResume(principal, dependencies) {
    const actor = requireCompletedProfile(principal);
    const resume = await dependencies.repository.getResume(actor.account.id);
    return resumeResponse(resume);
}
/** Updates only the freeform half (bio, skills) — the verified work-history
 * half is never accepted from the client at all, since it is always
 * recomputed live from `stable_memberships`. */
export async function updateResume(principal, input, dependencies) {
    const actor = requireCompletedProfile(principal);
    const parsed = updateResumeSchema.parse(input);
    const fields = validateResumeFields(parsed);
    const resume = await dependencies.repository.upsertResumeFields({
        horsemanId: actor.account.id,
        bio: fields.bio,
        skills: fields.skills,
        now: dependencies.clock.now(),
    });
    return resumeResponse(resume);
}
